import { z } from 'zod';

/////////////////////////////////////////
// CORE MAP LAYER FIELD DEFINITION SCHEMA
/////////////////////////////////////////

export const CoreMapLayerFieldDefinitionSchema = z.object({
  id: z.number().int(),
  cityId: z.number().int(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  rowTimestamp: z.coerce.date(),
  layerId: z.number().int(),
  customFieldId: z.number().int(),
  isPrimary: z.boolean(),
})

export type CoreMapLayerFieldDefinition = z.infer<typeof CoreMapLayerFieldDefinitionSchema>

export default CoreMapLayerFieldDefinitionSchema;
